// extracted by mini-css-extract-plugin
module.exports = {"main":"_1DCbpUEJ1CfOOxdeMLmkkt","footerLeft":"kZVo_32qfp1aUr1RQPLH3","footerRight":"_1YhMgwdy1wyy46iAKXNHZ9","back":"vPtcIDXkCV3hBAkWiXBSS"};